<template>
  <v-slide-y-transition mode="out-in">
    <div id="coa-forms" style="margin-top: -20px">
      <v-container grid-list-xl fluid>
        <v-layout row wrap>
          <v-flex lg6>          
            <v-card pa-0>              
              <v-divider></v-divider>
              <v-card-text class="">
                  <v-form v-model="valid">
                      <v-layout row wrap>                        
                          <v-flex sm8 lg8>
                          <v-text-field
                              label="Name"
                              name="name"                              
                              v-model="formModel.name"
                              v-validate="'required'"
                              data-vv-name="name"     
                              :error-messages="errors.collect('name')"  
                              required
                          ></v-text-field>
                          <v-textarea
                                class="primary--text"
                                name="description"
                                label="Description"                                
                                v-model="formModel.description"                                
                          ></v-textarea>    
                          </v-flex>
                           
                          <v-flex sm12 lg12>
                              <div class="form-btn">
                                  <v-btn v-if="!isUpdate" @click="save(isUpdate)" color="success">Create</v-btn>
                                  <v-btn v-else @click="save(isUpdate)" color="primary">Update</v-btn>                                                                    
                                  <v-btn outline @click="clear">Clear</v-btn>
                                </div>  
                          </v-flex>
                      </v-layout>                                                            
                  </v-form>  
              </v-card-text>       
            </v-card>
          </v-flex>                   
        </v-layout>
      </v-container>
    </div>
  </v-slide-y-transition>
</template>

<script>  
import Role from '@/apps/main/models/rbac/Role';    
import moment from 'moment';

var model = new Role();

export default {
    $_veeValidate: {
        validator: 'new'
    },    
    data: () => ({
        isUpdate:false,
        code: null,
        name:null,
        type: null,
        formModel: {
          id      : null,  
          name    : null,          
          description : null
        },
        //countries: Countries,
        balance: [],    
        valid: true
    }),
    created () {},    
    mounted () {this.init();}, 
    methods : {
        init(){
            if(this.$route.query.id){
                this.isUpdate  = true;
                model.one({id : this.$route.query.id }).then(data => {                      
                    Object.assign(this.formModel, data === null ? {}:data);   
                    this.formModel.id = this.formModel.name;
                    this.checking(data);
                });                                               
            }
            
            this.$validator.localize('en', this.dictionary);       
        },
        
        async save(isUpdate = false) {                
            this.$validator.validateAll();    
            this.formModel.time = moment().valueOf();
            this.formModel.info = null;            
            if( !this.errors.any() ) {
                var res = isUpdate ? await model.update(this.formModel): await model.create(this.formModel);                
                if(res.status === 200){  
                    this.$swal({ type: 'success', title: 'Your work has been saved', showConfirmButton: false, timer: 1000});                
                    this.$router.go(-1);                    
                } else {
                    var title = res.status ? '#'+res.status + ' Oops...' : 'Oops...';
                    var text  = res.statusText ? res.statusText: 'Something happened in setting up the request that triggered an Error.';                     
                    if(res.data){ if(res.data.message){ text += ' ' + res.data.message; } else {this.validate(res.data);}}                
                    this.$swal({type: 'error', title: title, text: text});                    
                }
            }             
        },
       
        validate(data){
            data.forEach( (item) => {
                this.$validator.errors.add({field : item.field,msg : item.message});
            });
        },        
                
        checking(data){
            if(data.info){
                if(data.info.action === 'synch' && data.info.data){
                    this.validate(data.info.data);
                }
            }            
        },        
                
        clear () {
            this.formModel = {};
            this.$validator.reset();
        }
    
             
    }
}
</script>